import React, { useEffect, useState } from "react";
import { Badge, Col, Form, Row, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import { eiwrsSiteInventoryServices } from "../../../../APIServices/EIWRS/eiwrsSiteInventoryServices";
import { eiwrsKitSchemaManagementServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitSchemaManagementServices";
import { eiwrsKitMetadataServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";

const AddNewStudyKitPreparation = ({
  getStudyKitPreparationData,
  depotList,
  treatmentList,
  kitTypeList,
  kitBatchList,
}) => {
  let { studyId } = useParams();
  const [depotId, setDepotId] = useState("");
  const [kitType, setKitType] = useState("");
  const [treatmentId, setTreatmentId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [batchNumber, setBatchNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [schemaId, setSchemaId] = useState("");
  const [kitPrefix, setKitPrefix] = useState("");
  const [kitStartingNumber, setKitStartingNumber] = useState("");
  const [kitSufix, setKitSufix] = useState("");
  const [kitJoiner, setKitJoiner] = useState("");
  const [columns, setColumns] = useState([]);
  const [kitSchemaList, setKitSchemaList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const addNewStudyKitPreparation = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.depotId = depotId;
    userData.kitType = kitType;
    userData.treatmentId = treatmentId;
    userData.quantity = quantity;
    userData.batchNumber = batchNumber;
    userData.expiryDate = expiryDate;
    userData.kitPrefix = kitPrefix;
    userData.kitStartingNumber = kitStartingNumber;
    userData.kitSuffix = kitSufix;
    userData.kitJoiner = kitJoiner;
    userData.columns = columns;
    userData.mode = StudyMode;
    let data =
      await eiwrsKitPreparationServices.addNewStudyKitPreparation(userData);
    if (data?.statusCode === 200) {
      setDepotId("");
      setKitType("");
      setTreatmentId("");
      setQuantity("");
      setBatchNumber("");
      setExpiryDate("");
      setKitPrefix("");
      setSchemaId("");
      setKitStartingNumber("");
      setKitSufix("");
      setKitJoiner("");
      getStudyKitPreparationData();
    }
    setButtonLoader(false);
  };

  const getEIWRSKitSchemaManagementData = async (e) => {
    let data = await eiwrsKitSchemaManagementServices.getEIWRSKitSchemaManagementData(
      "active",
      studyId,
    );
    setKitSchemaList(data?.data || []);
  };

  const getEIWRSKitMetadataData = async (e) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
    );
    let result = (data?.data || []).map(item => {
      return {
        columnId: item?.columnId,
        columnLabel: item?.columnLabel,
        columnName: item?.columnName,
        columnType: item?.columnType,
        isUnique: item?.isUnique,
        columnValue: "",
      };
    });
    setColumns(result);
  };

  const handleKitSchemaChange = (schemaId) => {
    let checkSchema = kitSchemaList?.find(item => item.schemaId === schemaId)
    setKitPrefix(checkSchema?.kitPrefix || "")
    setKitSufix(checkSchema?.kitSuffix || "")
    setKitJoiner(checkSchema?.kitJoiner || "")
    setKitStartingNumber(checkSchema?.kitStartingNumber || "")
    setSchemaId(schemaId)
  }

  const updateColumn = (columnId, field, value) => {
    setColumns((prev) =>
      prev.map((column) =>
        column.columnId === columnId
          ? {
            ...column,
            [field]: value,
          }
          : column
      )
    );
  };

  useEffect(() => {
    setDepotId("");
    setKitType("");
    setTreatmentId("");
    setQuantity("");
    setBatchNumber("");
    setSchemaId("");
    setExpiryDate("");
    setKitPrefix("");
    setKitStartingNumber("");
    setKitSufix("");
    setKitJoiner("");
    getEIWRSKitSchemaManagementData()
    getEIWRSKitMetadataData()
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Depot <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Select
          value={depotId}
          disabled={depotList?.length === 0}
          onChange={(e) => setDepotId(e.target.value)}
        >
          <option value="">Select Depot</option>
          {depotList?.map((item, index) => (
            <option key={index} value={item.depotId}>
              {item.row?.DEPOTID}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Kit Type <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Select
          value={kitType}
          onChange={(e) => setKitType(e.target.value)}
        >
          <option value="">Select Kit Type</option>
          {kitTypeList?.map((item, index) => (
            <option key={index} value={item.type}>
              {item.type}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Treatment <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Select
          value={treatmentId}
          onChange={(e) => setTreatmentId(e.target.value)}
        >
          <option value="">Select Treatment</option>
          {treatmentList?.map((item, index) => (
            <option key={index} value={item.treatmentId}>
              {item.row?.TREATMENTID}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Quantity <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setQuantity(e.target.value)}
          value={quantity}
          className="br3"
          placeholder="Enter Kit Quantity"
          type="number"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Batch Number <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Select
          value={batchNumber}
          onChange={(e) => setBatchNumber(e.target.value)}
        >
          <option value="">Select Batch Number</option>
          {kitBatchList?.map((item, index) => (
            <option key={index} value={item.batchNumber}>
              {item.batchNumber}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Expiry Date <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setExpiryDate(e.target.value)}
          value={expiryDate}
          className="br3"
          type="date"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">Kit Schema</Form.Label>
        <Form.Select
          value={schemaId}
          onChange={(e) => handleKitSchemaChange(e.target.value)}
        >
          <option value="">Select Kit Schema</option>
          {kitSchemaList?.map((item, index) => (
            <option key={index} value={item?.schemaId}>{item?.schemaName}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <div className="mt-3">
        {columns?.map((column, index) => (
          <div
            key={column.columnId}
            className="border rounded p-2 mb-2"
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <strong style={{ fontSize: 12 }}>{column.columnLabel} ({column.columnName})</strong>
              <Badge
                bg="primary-subtle"
                style={{ fontSize: 10 }}
                className={`CP text-capitalize br3 text-primary border-primary border px-2 text-capitalize mx-2`}
              >
                Unique: {column.isUnique}
              </Badge>
            </div>
            <Form.Control
              type={column.columnType}
              placeholder="Enter Column Value"
              value={column.columnValue}
              disabled={!column.columnType}
              onChange={(e) =>
                updateColumn(
                  column.columnId,
                  "columnValue",
                  e.target.value
                )
              }
            />
          </div>
        ))}
      </div>
      <div className="text-end">
        <button
          disabled={
            !depotId ||
            !treatmentId ||
            !kitType ||
            !quantity ||
            !batchNumber ||
            !kitStartingNumber ||
            !expiryDate ||
            buttonLoader
          }
          onClick={addNewStudyKitPreparation}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add Kit"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyKitPreparation;
